import React from "react";
import MagicalCard from "./MagicalCard";
import { Icon, EmptyState } from "./common";
import { useLang } from "../i18n";

export default function AchievementsPanel({ achievements = {}, categories = [], mine = true }) {
  const { t, pick } = useLang();
  const rows = categories.filter((c) => (achievements[c.key] || 0) > 0 || ["participation", "homework", "cooperation", "weekly_challenge"].includes(c.key));
  return (
    <MagicalCard title={mine ? t("dash.my_achievements") : t("dash.achievements")} variant="ribbon-cyan" testId="achievements-panel">
      {rows.length === 0 ? (
        <EmptyState icon="Sparkles" title={t("common.empty")} testId="achievements-empty" />
      ) : (
        <ul className="space-y-2">
          {rows.map((c) => (
            <li key={c.key} data-testid={`achievement-${c.key}`}
              className="flex items-center gap-3 rounded-2xl bg-[#0D0B38]/50 border border-white/8 px-3 py-2.5 hover:border-white/20 transition-colors">
              <span className="w-9 h-9 rounded-xl flex items-center justify-center shrink-0"
                style={{ background: `${c.color}26`, boxShadow: `0 0 10px ${c.color}33` }}>
                <Icon name={c.icon} className="w-4.5 h-4.5 w-5 h-5" style={{ color: c.color }} />
              </span>
              <span className="flex-1 text-sm font-bold">{pick(c, "name")}</span>
              <span className="text-lg font-black text-[#FFC83D] min-w-[1.6rem] text-center" style={{ textShadow: "0 0 12px rgba(255,200,61,0.4)" }}>
                {achievements[c.key] || 0}
              </span>
            </li>
          ))}
        </ul>
      )}
    </MagicalCard>
  );
}
